import { Column, Entity, Index, JoinColumn, ManyToMany, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { ILevel } from './interface/ILevel';
import { IBuilding } from './interface/IBuilding';
import { IObservation } from './interface/IObservation';
import { IVerification } from './interface/IVerification';

@Entity('level')
export class Level extends BaseEntity implements ILevel{
  apiMapping = {
    id: 'extId',
    localId: 'id',
    name: 'name',
    isDeleted: 'isDeleted',
    isNew: 'isNew',
    observations: {
      type: 'Observation',
      fieldName: 'observations',
      map: false,
      mapType: 'many',
    }
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column({ nullable: true })
  @Index()
  extId: number;

  @Column({ nullable: true })
  name: string;

  @Column({ nullable: true })
  isDeleted: boolean;

  @Column({ nullable: true })
  isNew: boolean;

  @ManyToOne('Building', 'levels')
  @JoinColumn()
  building: IBuilding;

  @ManyToMany('Observation', 'levels')
  observations: IObservation[];

  @ManyToOne('Verification', 'levels')
  @JoinColumn()
  verification: IVerification;
}
